import type { HttpClient, RequestOptions } from '../client.js';
import {
  type GetNetworkCalendarData,
  type GetNetworkCalendarParams,
  getNetworkCalendarParamsSchema,
} from '@spectrum-nodes/api-spec/models';
import { parseParams } from '../internals/validation.js';

/** Approved network calendar entries (releases / upgrades). */
export class NetworkCalendarNamespace {
  constructor(private readonly client: HttpClient) {}

  /**
   * List approved network calendar entries (releases / upgrades).
   * Optional filters: `month` (`YYYY-MM`), `day` (`YYYY-MM-DD` or `"today"`),
   * `chain` (network slug, e.g. `"ethereum"`).
   */
  async getNetworkCalendar(
    params: GetNetworkCalendarParams = {},
    options?: RequestOptions,
  ): Promise<GetNetworkCalendarData> {
    const validated = parseParams(getNetworkCalendarParamsSchema, params);
    return this.client.jsonRpc<GetNetworkCalendarData>('getNetworkCalendar', validated, options);
  }
}
